export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state("notificationList", {
      parent: "app",
      url: "/notifications?simple&company&basicAgreement&cardnr&cardowner",
      feature: "menu.settings.notifications",
      /*executeUserCheck: function canReadUsers(user) {
       return user.effectiveUserObjectPermissions && user.effectiveUserObjectPermissions.userObjectsRead;
       },*/
      views: {
        "main": {
          template: require("./eaNotificationPage/eaNotificationPageModule.html"),
          controller: "eaNotificationPageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }],
        companyFilterEnabled: ["UserService", (UserService) => {
          return UserService.hasFeature("settingsUserListPage.companyFilterEnabled");
        }]
      }
    });
}];


// WEBPACK FOOTER //
// ./src/ui/modules/eaSettings/eaNotification/routes.js